// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2m-vB","label":"styles_label__1OcGX"};